import { useContext, useEffect, useRef } from 'react';

import type { LifeCycleCallback } from '../contexts/FmlLifeCycleContext';
import { FmlLifeCycleContext } from '../contexts/FmlLifeCycleContext';

export const useFmlViewWillEnter = (callback: LifeCycleCallback, deps: any[] = []) => {
  const context = useContext(FmlLifeCycleContext);
  const id = useRef<number | undefined>();
  id.current = id.current || Math.floor(Math.random() * 1000000);
  useEffect(() => {
    callback.id = id.current!;
    context.onFmlViewWillEnter(callback);
    return () => {
      context.cleanupFmlViewWillEnter(callback);
    };
  }, deps);
};

export const useFmlViewDidEnter = (callback: LifeCycleCallback, deps: any[] = []) => {
  const context = useContext(FmlLifeCycleContext);
  const id = useRef<number | undefined>();
  id.current = id.current || Math.floor(Math.random() * 1000000);
  useEffect(() => {
    callback.id = id.current!;
    context.onFmlViewDidEnter(callback);
    return () => {
      context.cleanupFmlViewDidEnter(callback);
    };
  }, deps);
};

export const useFmlViewWillLeave = (callback: LifeCycleCallback, deps: any[] = []) => {
  const context = useContext(FmlLifeCycleContext);
  const id = useRef<number | undefined>();
  id.current = id.current || Math.floor(Math.random() * 1000000);
  useEffect(() => {
    callback.id = id.current!;
    context.onFmlViewWillLeave(callback);
    return () => {
      context.cleanupFmlViewWillLeave(callback);
    };
  }, deps);
};

export const useFmlViewDidLeave = (callback: LifeCycleCallback, deps: any[] = []) => {
  const context = useContext(FmlLifeCycleContext);
  const id = useRef<number | undefined>();
  id.current = id.current || Math.floor(Math.random() * 1000000);
  useEffect(() => {
    callback.id = id.current!;
    context.onFmlViewDidLeave(callback);
    return () => {
      context.cleanupFmlViewDidLeave(callback);
    };
  }, deps);
};
